var region_val = '';
var region_val_input = '';
$('.region-selector-wrapper, .store-selector-wrapper').hide();
setTimeout(function(){ 
  	$('ul .region-selector').each(function(){
      region_val = $(this).attr('data-value');
      region_val = region_val.replace('Alajuela -> ', '');
      region_val = region_val.replace('Atenas -> ', '');
      region_val = region_val.replace('Barva -> ', '');
      region_val = region_val.replace('Belén -> ', '');
      region_val = region_val.replace('Buenos Aires -> ', '');
      region_val = region_val.replace('Cañas -> ', '');
      region_val = region_val.replace('Carrillo -> ', '');
      region_val = region_val.replace('Cartago -> ', '');
      region_val = region_val.replace('Corredores -> ', '');
      region_val = region_val.replace('Curridabat -> ', '');
      region_val = region_val.replace('Desamparados -> ', '');
      region_val = region_val.replace('Escazú -> ', '');
      region_val = region_val.replace('Esparza -> ', '');
      region_val = region_val.replace('Garabito -> ', '');
      region_val = region_val.replace('Goicoechea -> ', '');
      region_val = region_val.replace('Grecia -> ', '');
      region_val = region_val.replace('Heredia -> ', '');
      region_val = region_val.replace('La Unión -> ', '');
      region_val = region_val.replace('Liberia -> ', '');
      region_val = region_val.replace('Montes de Oca -> ', '');
      region_val = region_val.replace('Mora -> ', '');
      region_val = region_val.replace('Moravia -> ', '');
      region_val = region_val.replace('Naranjo -> ', '');
      region_val = region_val.replace('Nicoya -> ', '');
      region_val = region_val.replace('Orotina -> ', '');
      region_val = region_val.replace('Osa -> ', '');
      region_val = region_val.replace('Palmares -> ', '');
      region_val = region_val.replace('Paraíso -> ', '');
      region_val = region_val.replace('Pérez Zeledón -> ', '');
      region_val = region_val.replace('Pococí -> ', '');
      region_val = region_val.replace('Puntarenas -> ', '');
      region_val = region_val.replace('Puriscal -> ', '');
      region_val = region_val.replace('Quepos -> ', '');
      region_val = region_val.replace('San Carlos -> ', '');
      region_val = region_val.replace('San José -> ', '');
      region_val = region_val.replace('San Rafael -> ', '');
      region_val = region_val.replace('San Ramón -> ', '');
      region_val = region_val.replace('Santa Ana -> ', '');
      region_val = region_val.replace('Santa Cruz -> ', '');
      region_val = region_val.replace('Santo Domingo -> ', '');
      region_val = region_val.replace('Tibás -> ', '');
      region_val = region_val.replace('Turrialba -> ', '');
      region_val = region_val.replace('Vazquez de Coronado -> ', '');
    $(this).text(region_val);
});
}, 100);

$('.select-provincia').change(function(){
    $('.canton-selector-wrapper select option').each(function(){$(this).remove();});
    $('.selector-wrapper').show();
    $('ul .region-selector').css('display', 'none');
    $('.region-selector-input').val('-- Seleccionar Distrito --');
    $('.store-selector-input').val('-- Seleccionar Tienda --');
    //$('.region-selector-wrapper, .store-selector-wrapper').show();
	var provincia = $(this).val();
  	if(provincia == 'Alajuela'){
      $('.canton-selector-wrapper select').append('<option value="Alajuela">Alajuela</option>');
      $('.canton-selector-wrapper select').append('<option value="Atenas">Atenas</option>');
      $('.canton-selector-wrapper select').append('<option value="Grecia">Grecia</option>');
      $('.canton-selector-wrapper select').append('<option value="Naranjo">Naranjo</option>');
      $('.canton-selector-wrapper select').append('<option value="Orotina">Orotina</option>');
      $('.canton-selector-wrapper select').append('<option value="Palmares">Palmares</option>');
      $('.canton-selector-wrapper select').append('<option value="San Carlos">San Carlos</option>');
      $('.canton-selector-wrapper select').append('<option value="San Ramón">San Ramón</option>');
      $( "li[data-value*='Alajuela ->']" ).show();
    }else if(provincia == 'Cartago'){
      $('.canton-selector-wrapper select').append('<option value="Cartago">Cartago</option>');
      $('.canton-selector-wrapper select').append('<option value="La Unión">La Unión</option>');
      $('.canton-selector-wrapper select').append('<option value="Paraíso">Paraíso</option>');
      $('.canton-selector-wrapper select').append('<option value="Turrialba">Turrialba</option>');
      $( "li[data-value*='Cartago ->']" ).show();
    }else if(provincia == 'Guanacaste'){
      $('.canton-selector-wrapper select').append('<option value="Cañas">Cañas</option>');
      $('.canton-selector-wrapper select').append('<option value="Carrillo">Carrillo</option>');
      $('.canton-selector-wrapper select').append('<option value="Liberia">Liberia</option>');
      $('.canton-selector-wrapper select').append('<option value="Nicoya">Nicoya</option>');
      $('.canton-selector-wrapper select').append('<option value="Santa Cruz">Santa Cruz</option>');
      $( "li[data-value*='Guanacaste ->']" ).show();
    }else if(provincia == 'Heredia'){
      $('.canton-selector-wrapper select').append('<option value="Barva">Barva</option>');
      $('.canton-selector-wrapper select').append('<option value="Belén">Belén</option>');
      $('.canton-selector-wrapper select').append('<option value="Heredia">Heredia</option>');
      $('.canton-selector-wrapper select').append('<option value="San Rafael">San Rafael</option>');
      $('.canton-selector-wrapper select').append('<option value="Santo Domingo">Santo Domingo</option>');
      $( "li[data-value*='Heredia ->']" ).show();
    }else if(provincia == 'Limón'){
      $('.canton-selector-wrapper select').append('<option value="Pococí">Pococí</option>');
      $( "li[data-value*='Limón ->']" ).show();
    }else if(provincia == 'Puntarenas'){
      $('.canton-selector-wrapper select').append('<option value="Buenos Aires">Buenos Aires</option>');
      $('.canton-selector-wrapper select').append('<option value="Corredores">Corredores</option>');
      $('.canton-selector-wrapper select').append('<option value="Esparza">Esparza</option>');
      $('.canton-selector-wrapper select').append('<option value="Garabito">Garabito</option>');
      $('.canton-selector-wrapper select').append('<option value="Osa">Osa</option>');
      $('.canton-selector-wrapper select').append('<option value="Puntarenas">Puntarenas</option>');
      $('.canton-selector-wrapper select').append('<option value="Quepos">Quepos</option>');
      $( "li[data-value*='Puntarenas ->']" ).show();
    }else if(provincia == 'San José'){
      $('.canton-selector-wrapper select').append('<option value="Curridabat">Curridabat</option>');
      $('.canton-selector-wrapper select').append('<option value="Desamparados">Desamparados</option>');
      $('.canton-selector-wrapper select').append('<option value="Escazú">Escazú</option>');
      $('.canton-selector-wrapper select').append('<option value="Goicoechea">Goicoechea</option>');
      $('.canton-selector-wrapper select').append('<option value="Montes de Oca">Montes de Oca</option>');
      $('.canton-selector-wrapper select').append('<option value="Mora">Mora</option>');
      $('.canton-selector-wrapper select').append('<option value="Moravia">Moravia</option>');
      $('.canton-selector-wrapper select').append('<option value="Pérez Zeledón">Pérez Zeledón</option>');
      $('.canton-selector-wrapper select').append('<option value="Puriscal">Puriscal</option>');
      $('.canton-selector-wrapper select').append('<option value="San José">San José</option>');
      $('.canton-selector-wrapper select').append('<option value="Santa Ana">Santa Ana</option>');
      $('.canton-selector-wrapper select').append('<option value="Tibás">Tibás</option>');
      $('.canton-selector-wrapper select').append('<option value="Vazquez de Coronado">Vazquez de Coronado</option>');
      $( "li[data-value*='San José ->']" ).show();
    }
});

$('.select-canton').change(function(){
    $('.region-selector-input').val('-- Seleccionar Distrito --');
    $('.store-selector-input').val('-- Seleccionar Tienda --');
    $('.region-selector-wrapper, .store-selector-wrapper').show();
	var canton = $(this).val();
  switch (canton) {
    case "Alajuela":
      $("li.region-selector").hide();
      $( "li[data-value*='Alajuela -> ']" ).show();
      break;
    case "Atenas":
      $("li.region-selector").hide();
      $( "li[data-value*='Atenas -> ']" ).show();
      break;
    case "Grecia":
      $("li.region-selector").hide();
      $( "li[data-value*='Grecia -> ']" ).show();
      break;
    case "Naranjo":
      $("li.region-selector").hide();
      $( "li[data-value*='Naranjo -> ']" ).show();
      break;
    case "Orotina":
      $("li.region-selector").hide();
      $( "li[data-value*='Orotina -> ']" ).show();
      break;
    case "Palmares":
      $("li.region-selector").hide();
      $( "li[data-value*='Palmares -> ']" ).show();
      break;
    case "San Carlos":
      $("li.region-selector").hide();
      $( "li[data-value*='San Carlos -> ']" ).show();
      break;
    case "San Ramón":
      $("li.region-selector").hide();
      $( "li[data-value*='San Ramón -> ']" ).show();
      break;
    case "Cartago":
      $("li.region-selector").hide();
      $( "li[data-value*='Cartago -> ']" ).show();
      break;
    case "La Unión":
      $("li.region-selector").hide();
      $( "li[data-value*='La Unión -> ']" ).show();
      break;
    case "Paraíso":
      $("li.region-selector").hide();
      $( "li[data-value*='Paraíso -> ']" ).show();
      break;
    case "Turrialba":
      $("li.region-selector").hide();
      $( "li[data-value*='Turrialba -> ']" ).show();
      break;
    case "Cañas":
      $("li.region-selector").hide();
      $( "li[data-value*='Cañas -> ']" ).show();
      break;
    case "Carrillo":
      $("li.region-selector").hide();
      $( "li[data-value*='Carrillo -> ']" ).show();
      break;
    case "Liberia":
      $("li.region-selector").hide();
      $( "li[data-value*='Liberia -> ']" ).show();
      break;
    case "Nicoya":
      $("li.region-selector").hide();
      $( "li[data-value*='Nicoya -> ']" ).show();
      break;
    case "Santa Cruz":
      $("li.region-selector").hide();
      $( "li[data-value*='Santa Cruz -> ']" ).show();
      break;
    case "Barva":
      $("li.region-selector").hide();
      $( "li[data-value*='Barva -> ']" ).show();
      break;
    case "Belén":
      $("li.region-selector").hide();
      $( "li[data-value*='Belén -> ']" ).show();
      break;
    case "Heredia":
      $("li.region-selector").hide();
      $( "li[data-value*='Heredia -> ']" ).show();
      break;
    case "San Rafael":
      $("li.region-selector").hide();
      $( "li[data-value*='San Rafael -> ']" ).show();
      break;
    case "Santo Domingo":
      $("li.region-selector").hide();
      $( "li[data-value*='Santo Domingo -> ']" ).show();
      break;
    case "Pococí":
      $("li.region-selector").hide();
      $( "li[data-value*='Pococí -> ']" ).show();
      break;
    case "Buenos Aires":
      $("li.region-selector").hide();
      $( "li[data-value*='Buenos Aires -> ']" ).show();
      break;
    case "Corredores":
      $("li.region-selector").hide();
      $( "li[data-value*='Corredores -> ']" ).show();
      break;
    case "Esparza":
      $("li.region-selector").hide();
      $( "li[data-value*='Esparza -> ']" ).show();
      break;
    case "Garabito":
      $("li.region-selector").hide();
      $( "li[data-value*='Garabito -> ']" ).show();
      break;
    case "Osa":
      $("li.region-selector").hide();
      $( "li[data-value*='Osa -> ']" ).show();
      break;
    case "Puntarenas":
      $("li.region-selector").hide();
      $( "li[data-value*='Puntarenas -> ']" ).show();
      break;
    case "Quepos":
      $("li.region-selector").hide();
      $( "li[data-value*='Quepos -> ']" ).show();
      break;
    case "Curridabat":
      $("li.region-selector").hide();
      $( "li[data-value*='Curridabat -> ']" ).show();
      break;
    case "Desamparados":
      $("li.region-selector").hide();
      $( "li[data-value*='Desamparados -> ']" ).show();
      break;
    case "Escazú":
      $("li.region-selector").hide();
      $( "li[data-value*='Escazú -> ']" ).show();
      break;
    case "Goicoechea":
      $("li.region-selector").hide();
      $( "li[data-value*='Goicoechea -> ']" ).show();
      break;
    case "Montes de Oca":
      $("li.region-selector").hide();
      $( "li[data-value*='Montes de Oca -> ']" ).show();
      break;
    case "Mora":
      $("li.region-selector").hide();
      $( "li[data-value*='Mora -> ']" ).show();
      break;
    case "Moravia":
      $("li.region-selector").hide();
      $( "li[data-value*='Moravia -> ']" ).show();
      break;
    case "Pérez Zeledón":
      $("li.region-selector").hide();
      $( "li[data-value*='Pérez Zeledón -> ']" ).show();
      break;
    case "Puriscal":
      $("li.region-selector").hide();
      $( "li[data-value*='Puriscal -> ']" ).show();
      break;
    case "San José":
      $("li.region-selector").hide();
      $( "li[data-value*='San José -> ']" ).show();
      break;
    case "Santa Ana":
      $("li.region-selector").hide();
      $( "li[data-value*='Santa Ana -> ']" ).show();
      break;
    case "Tibás":
      $("li.region-selector").hide();
      $( "li[data-value*='Tibás -> ']" ).show();
      break;
    case "Vazquez de Coronado":
      $("li.region-selector").hide();
      $( "li[data-value*='Vazquez de Coronado -> ']" ).show();
      break;
  }
});

//COVID ISSUES
setTimeout(function(){   
//   $('#box-filtro-tienda select option').remove();
//   $('<option value="Null">-- Seleccionar provincia --</option>').appendTo('#box-filtro-tienda select');
//   $('<option value="Arequipa">Arequipa</option>').appendTo('#box-filtro-tienda select');
//   $('<option value="Junin">Junin</option>').appendTo('#box-filtro-tienda select');
//   $('<option value="La Libertad">La Libertad</option>').appendTo('#box-filtro-tienda select');
//   $('<option value="Lima">Lima</option>').appendTo('#box-filtro-tienda select');
//   $('<option value="Piura">Piura</option>').appendTo('#box-filtro-tienda select');
  

//   $('.region-selector-wrapper ul li.region-selector').remove();
//   $('<li class="region-selector" data-value="-- Seleccionar Distrito --">-- Seleccionar Distrito --</li>').appendTo('.region-selector-wrapper ul');
  
//   $('<li class="region-selector" data-value="Arequipa-> Arequipa">Arequipa-> Arequipa</li>').appendTo('.region-selector-wrapper ul');
//   $('<li class="region-selector" data-value="Arequipa-> Paucarpata">Arequipa-> Paucarpata</li>').appendTo('.region-selector-wrapper ul');
  
//   $('<li class="region-selector" data-value="Junin-> Huancayo">Junin-> Huancayo</li>').appendTo('.region-selector-wrapper ul');
  
//   $('<li class="region-selector" data-value="La Libertad-> Trujillo">La Libertad-> Trujillo</li>').appendTo('.region-selector-wrapper ul');
  
//   $('<li class="region-selector" data-value="Lima-> Chorrillos">Lima-> Chorrillos</li>').appendTo('.region-selector-wrapper ul');
//   $('<li class="region-selector" data-value="Lima-> Miraflores">Lima-> Miraflores</li>').appendTo('.region-selector-wrapper ul');
//   $('<li class="region-selector" data-value="Lima-> La Molina">Lima-> La Molina</li>').appendTo('.region-selector-wrapper ul');
//   $('<li class="region-selector" data-value="Lima-> San Isidro">Lima-> San Isidro</li>').appendTo('.region-selector-wrapper ul');
//   $('<li class="region-selector san-juan" data-value="Lima-> San Juan De Miraflores">Lima-> San Juan De Miraflores</li>').appendTo('.region-selector-wrapper ul');
//   $('<li class="region-selector surco" data-value="Lima-> Santiago De Surco">Lima-> Santiago De Surco</li>').appendTo('.region-selector-wrapper ul');
//   $('<li class="region-selector" data-value="Lima-> San Borja">Lima-> San Borja</li>').appendTo('.region-selector-wrapper ul');
//   $('<li class="region-selector" data-value="Lima-> San Miguel">Lima-> San Miguel</li>').appendTo('.region-selector-wrapper ul');
//   $('<li class="region-selector" data-value="Lima-> San Martín de Porres">Lima-> San Martín de Porres</li>').appendTo('.region-selector-wrapper ul');
//   $('<li class="region-selector" data-value="Lima-> Santa Anita">Lima-> Santa Anita</li>').appendTo('.region-selector-wrapper ul');
//   $('<li class="region-selector" data-value="Lima-> Surquillo">Lima-> Surquillo</li>').appendTo('.region-selector-wrapper ul');

//   $('<li class="region-selector" data-value="Piura-> Piura">Piura-> Piura</li>').appendTo('.region-selector-wrapper ul');


}, 300);

setTimeout(function(){

  $('.surco').click(function(){
    setTimeout(function(){ 
//     $('.store-selector-wrapper ul li.store-selector').remove();
//     $('<li class="store-selector" data-value="Chacarilla">Chacarilla</li>').appendTo('.store-selector-wrapper ul');
//     $('<li class="store-selector" data-value="Chacarilla 2">Chacarilla 2</li>').appendTo('.store-selector-wrapper ul');
// 	$('<li class="store-selector" data-value="El Polo">El Polo</li>').appendTo('.store-selector-wrapper ul');
//     $('<li class="store-selector" data-value="Jockey Plaza">Jockey Plaza</li>').appendTo('.store-selector-wrapper ul');

    }, 200);
  });
  

}, 400);
